import { link } from 'fs';

export const footerNavigation = [
  { name: 'Transparência', link: '/transparencia' },
  { name: 'Ouvidoria', link: '/ouvidoria' },
  { name: 'FAQ', link: '/faq' },
  { name: 'Política de Privacidade', link: '/politica-de-privacidade' },
  { name: 'Nossos Planos', link: '/planos' },
];
